import { z } from "zod";

import { SlackBotIdentitySchema } from "./SlackBotIdentity.schema";
import { SlackTeamInfoSchema } from "./SlackTeamInfo.schema";
import { WebhookSettingsSchema } from "./WebhookSettings.schema";

export const SlackBotConnectionSettingsSchema = z.object({
  /** Slack app ID */
  appId: z.string().optional(),
  /** Team/workspace info */
  team: SlackTeamInfoSchema.optional(),
  /** Bot info */
  bot: SlackBotIdentitySchema.optional(),
  /** Whether credentials have been validated */
  validated: z.boolean().optional(),
  /** When credentials were last validated */
  validatedAt: z.string().optional(),
  /** Whether signing secret is configured (for webhook verification) */
  hasSigningSecret: z.boolean().optional(),
  /** Webhook registration status */
  webhook: WebhookSettingsSchema.optional(),
  /**
   * Manifest version — tracks which scope/event set was last synced to Slack.
   * undefined/0 = legacy (created before comprehensive scope overhaul, ~9 scopes)
   * 1 = current (35 scopes, 14 events — matches SLACK_MANIFEST_VERSION)
   * 2+ = future additions
   */
  manifestVersion: z.number().int().min(0).optional()
});
export type SlackBotConnectionSettings = z.infer<typeof SlackBotConnectionSettingsSchema>;

// Keep old type alias for backwards compatibility
export const SlackApiKeyConnectionSettingsSchema = SlackBotConnectionSettingsSchema;
export type SlackApiKeyConnectionSettings = SlackBotConnectionSettings;
